module.exports = __webpack_public_path__ + "img/int12.66cad66b.jpg";